<template>
    <section class="transfer-places-add-form">
        <el-form
            ref="form"
            v-loading="isLoading"
            :model="form"
            :rules="rules"
        >
            <el-form-item
                label="Название"
                prop="name"
            >
                <el-input
                    v-model="form.name"
                    label="Название"
                />
            </el-form-item>
            <el-form-item label="Информация">
                <el-input
                    v-model="form.description"
                    type="textarea"
                    label="Информация"
                />
            </el-form-item>
        </el-form>
        <div>
            <el-button
                type="success"
                @click="_submitForm"
            >
                Сохранить
            </el-button>
        </div>
    </section>
</template>

<script>
import ROUTES from '@/modules/transfer/enums/routes';
import _ from 'lodash';
import { mapActions } from 'vuex';

export default {
    name: 'TransferPlacesAddForm',
    data() {
        return {
            isLoading: false,
            form: {
                name: null,
                description: null
            },
            rules: {
                name: [
                    { required: true, message: 'Укажите название', trigger: 'change' }
                ]
            }
        };
    },
    methods: {
        ...mapActions('transfer', [
            'createPlace'
        ]),
        _submitForm() {
            this.$refs.form.validate()
                .then(() => {
                    this._createPlace();
                });
        },
        _createPlace() {
            this.isLoading = true;
            this.createPlace({ ...this.form })
                .then((response) => {
                    if (response.success) {
                        this.$message.success(response.message);
                        this.$router.push({ name: ROUTES.TRANSFER_PLACES.LIST });
                        return;
                    }
                    throw new Error(response.message);
                })
                .catch((error) => {
                    let message = _.get(error, 'response.data.message') || error.message;
                    this.$message.error(message);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>

<style lang="scss">
.transfer-places-add-form {
  max-width: 510px;
}
</style>
